import { PropertiesCard } from "../Cards/PropertiesCard"
import { ProgressChart } from "../CHARTS/Progress/ProgressChart";


export const defaultColorGradient = ['#2DACDE', '#B2C651', '#FBD404', '#FFA026', '#FF5D57'];

const dateMapper = (x) => {
  let date = new Date(x * 1000);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

const daysMapper = (x) => x / (24 * 3600);
const remainingDays = (x) => {
  let days = daysMapper(x);
  return `${days >= 0 ? days : 0} days`;
}

const defaultMapper = (x) => x.toLocaleString('en-US');

const TimeControls = ({ name, short_name, controls, showAsKeyValue, isDate, note }) => {
  return (
    showAsKeyValue ?
      <PropertiesCard object={{
        title: short_name,
        subtitle: name,
        ...controls.reduce((obj, control) => ({ ...obj, [control.name]: isDate ? dateMapper(control.value) : defaultMapper(control.value) }), {})
      }} horizontalCard >
      </PropertiesCard> :
      <ProgressChart
      note={note}
        title={short_name}
        subtitle={name}
        data={controls.reduce((obj, control) => ({
          ...obj,
          [control.name]: {
            ...control,
            colorGradient: defaultColorGradient,
            solidOverflow: true,
            showValueLabel: true,
            maxMap: isDate ? dateMapper : defaultMapper,
            valueMap: isDate ? dateMapper : defaultMapper,
            remainingMap: isDate ? dateMapper : defaultMapper,
            tooltip: `Current: ${(isDate ? dateMapper : defaultMapper)?.(control.value) } ${isDate ? '' : control.name}, Total: ${(isDate ? dateMapper : defaultMapper)?.(control.max) } ${isDate ? '' : control.name}, Remaining: ${(isDate ? remainingDays : defaultMapper)?.(control.remaining) } ${isDate ? '' : control.name}`
          }
        }), {})} ></ProgressChart>
  )
}

export default TimeControls;